

import "./BottomBar_text.css";

import GithubImg from "./images/GitHub-Mark-Light-120px-plus.png";
import LinkedinImg from "./images/logo-large-linkedin.png";
import EmailImg from "./images/logo-large-email.png";

const BottomBarLinkElement = (props) =>
{
	//let source = "./images/" + props.source;
	////// 	<img src={require(source)} alt={props.name + " logo"}/>

	return(
		<a href={props.link} target="_blank" rel="noopener noreferrer">
			<div className="link-element">

				<img src={props.image} alt={props.name + " logo"} className="link-image"/>

			</div>
		</a>
	)
}


const BottomBarText = () =>
{
	/// <BottomBarLinkElement name="email" link="http://outlook.com" source="logo-email.png"/>

	return(
		<div style={{float: "right", marginBottom: "15px"}}>

			<BottomBarLinkElement name="github" link="https://github.com/maxska" image={GithubImg}/>

			<BottomBarLinkElement name="linkedin" link="https://se.linkedin.com/in/max-skanvik" image={LinkedinImg}/>

			<BottomBarLinkElement name="email" link="mailto:maxskan98@gmail.com" image={EmailImg}/>

		</div>
	)
}

export default BottomBarText;